import { DeleteIcon } from "@/assets/icons";
import { LoadingButton } from '@altimateai/lego'
import { Popconfirm } from '@altimateai/lego'
import useUserGroupEntityDelete from "./useUserGroupEntityDelete";
import {
  deleteRuleInUserGroup,
  deleteUserGroup,
  deleteUserInUserGroup,
  deleteOwnershipInUserGroup,
} from "@/helpers/apis";
import { EntityType } from "./types";

interface Props {
  id: string;
  entityId: string;
  refetch: () => void;
  entityType: EntityType;
  title: string;
}

const DeleteWithConfirm = ({ id, entityId, refetch, entityType, title }: Props) => {
  const {
    deleteEntity,
    isDeletingEntity,
    entityBeingDeleted,
    entityType: entityTypeBeingDeleted,
  } = useUserGroupEntityDelete({
    onDelete: (entityId: string, type: EntityType) => {
      if (type === "rule") {
        return deleteRuleInUserGroup(entityId, id);
      }
      if (type === "user") {
        return deleteUserInUserGroup(entityId, id);
      }
      if (type === "ownership") {
        return deleteOwnershipInUserGroup(entityId, id);
      }
      if (type === "usergroup") {
        return deleteUserGroup(entityId);
      }
    },
    refetch,
  });

  return (
    <Popconfirm
      title={`Delete`}
      description={`Are you sure to delete this ownership rule?`}
      onConfirm={e => {
        e?.stopPropagation();
        deleteEntity(entityId, entityType, "this ownership rule");
      }}
      onCancel={e => {
        e?.stopPropagation();
      }}
      okText="Yes"
      cancelText="No"
    >
      <LoadingButton
        title={title}
        loading={
          entityTypeBeingDeleted === entityType &&
          isDeletingEntity &&
          entityBeingDeleted === entityId
        }
        variant="ghost"
        className="al-border-0 al-p-0 al-h-[14px]"
      >
        <DeleteIcon style={{ width: 14, height: 14 }} />
      </LoadingButton>
    </Popconfirm>
  );
};

export default DeleteWithConfirm;
